export const ADMIN_AUDIT_LIVE_REQUEST_DATA =
  'auditLive/ADMIN_AUDIT_LIVE_REQUEST_DATA';
export const ADMIN_AUDIT_LIVE_RECEIVE_DATA =
  'auditLive/ADMIN_AUDIT_LIVE_RECEIVE_DATA';
